import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const planViewNotFoundRoute: InvariantJiraRoute = {
	name: 'plan-view-not-found',
	path: '/jira/plans/:planId/scenarios/:scenarioId/not-found',
};
